import classNames from 'classnames'
import { Icon, type ITooltipProps, Tooltip, Typography } from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { TextFieldPlaceholder } from 'shared/ui/TextField'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import styles from './styles.module.scss'

type SendFromRcsProps = {
  inbox: Inbox
  variant?: 'vertical' | 'horizontal'
  tooltipProps?: ITooltipProps
}

type ITriggerProps = SendFromRcsProps

const Trigger = ({ inbox, variant = 'horizontal', tooltipProps }: ITriggerProps) => {
  return (
    <Tooltip
      fullWidth
      label={
        <>
          Only one RCS inbox available.
          <br />
          Switch tabs to send SMS or Ringless.
        </>
      }
      placement={'top'}
      {...tooltipProps}
    >
      <TextFieldPlaceholder
        placeholder={
          <div className={styles.wrapPlaceholder}>
            <div className={styles.trigger__icon}>
              <Icon icon={'rcs'} tertiary />
            </div>

            <Typography variant={'text-input-field'} ariaLabel={'rcsInbox'} ellipsis>
              {inbox.name}
            </Typography>
          </div>
        }
        variant={variant === 'vertical' ? 'stroke' : 'outline'}
        size={variant === 'vertical' ? 'medium' : 'small'}
        className={styles.input}
        viewOnly={false}
      />
    </Tooltip>
  )
}

export const SendFromRcs = ({ inbox, variant = 'horizontal', tooltipProps }: SendFromRcsProps) => {
  return (
    <div className={classNames(styles.wrap, { [styles.vertical]: variant === 'vertical' })}>
      <Label
        label={{
          text: 'Send from',
          horizontal: variant === 'horizontal',
          className: classNames(styles.label, { [styles.vertical]: variant === 'vertical' }),
        }}
      />
      <Trigger inbox={inbox} variant={variant} tooltipProps={tooltipProps} />
    </div>
  )
}
